export function getTriggerFromModifier(modifier: string): string | undefined {
  const triggers = getAllTriggersFromModifier(modifier);
  return triggers.length > 0 ? triggers[0] : undefined;
}

export function getAllTriggersFromModifier(modifier: string): string[] {
  if (modifier === undefined || modifier === null) {
    console.warn('Modifier is undefined or null');
    return [];
  }

  if (typeof modifier !== 'string') {
    console.warn('Modifier is not a string:', typeof modifier);
    return [];
  }

  const triggers = modifier.match(/{([^}]*)}/g);

  return triggers ? triggers.map(trigger => trigger.slice(1, -1)) : [];
}